/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type AreaOfStudyEntity, areaOfStudySchema } from '@axiom/domain';
import { AreaOfStudyCategory } from '../../../enums/generated/area-of-study-category';

/** ReadAreasOfStudyResponse — dark-roast DTO: GetAreaOfStudyResponseDto; also used by readAreaOfStudy */
export const readAreasOfStudyResponseSchema = areaOfStudySchema.pick({ "id": true, "name": true }).extend({ "category": z.nativeEnum(AreaOfStudyCategory).nullish(), "isStem": z.boolean() });
export type ReadAreasOfStudyResponse = Pick<AreaOfStudyEntity, "id" | "name"> & z.infer<typeof readAreasOfStudyResponseSchema>;
